import React, { useState, useEffect } from 'react';
// import axios from 'axios';

import Language from '../language';


const Main = ({ data, result, SetUser, step, setStep }) => {

  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');

  useEffect(() => {
    if (result && result.user) {
      setName(result.user.name);
      setCompany(result.user.company);
      setEmail(result.user.email);
    }
  }, []);

  const startGame = event => {
    event.preventDefault();
    let userData = {name, company, email};
    SetUser({ user: userData });
    console.log('userData', userData );

    // let formData = new FormData();
    // formData.append('name', userData.name)
    // formData.append('company', userData.company)
    // formData.append('email', userData.email)

    // axios({
    //   method: 'POST',
    //   url: 'indexT.php',
    //   config: { headers: {'Content-Type': 'multipart/form-data' }},
    //   data: formData
    // }).then(result => {
    //   console.log('result send', result );
    // }).catch(error => console.error('error', error ) );

    setStep(step + 1);
  };

  /*
<form onSubmit={startGame} className="intro-form">
</form>
onClick={startGame} 
  */

  return (
    
    
    
    
    <div className="main-wrapper">
      <h1 className="title">{data && data.intro.title}</h1>
      <div className="intro-video">
      <iframe width="790" height="360" src={data && data.intro.video} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
      </div>

      <div className="intro-info">{data && data.intro.info}</div>
      <Language />
      
      <form onSubmit={startGame} className="intro-form">
      <div className="form-container">
        <div className="intro-form">
          <div className="input-wrapper">
            <input
              type="text"
              name="name"
              value={name}
              onChange={event => setName(event.target.value)}
              placeholder={ data && data.intro.inputs.name }
              required
            />
          </div>
          <div className="input-wrapper">
            <input
              type="text"
              name="company"
              value={company}
              onChange={event => setCompany(event.target.value)}
              placeholder={ data && data.intro.inputs.company }
              required
            />
          </div>
          <div className="input-wrapper">
            <input
              type="email"
              name="email"
              value={email}
              onChange={event => setEmail(event.target.value)}
              placeholder={ data && data.intro.inputs.email }
              required
            />
          </div>
          <div className="btn-wrapper">
            <button className="btn">{ data && data.intro.start }</button>
          </div>
        </div>
      </div>
      </form>
      
    </div>


  );
};

export default Main;
